import type { IconData } from '@stacksjs/iconify-core'

export const basicUiUnlock: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3 6V5a5 5 0 0 1 9.975-.5H9.937A2 2 0 0 0 6 5v1h9v10H1V6zm5 6.252a1.252 1.252 0 1 0 0-2.504a1.252 1.252 0 0 0 0 2.504\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiUnlock
